import { DepartmentModel } from "@app/catalog";

export class DepartmentUpdatedMessage {
    public department: DepartmentModel;
    
    constructor(department: DepartmentModel)
    {
        this.department = department;
    }
}